import * as Dialog from '@studio/design-system/dialog';
import { useComposedRefs } from '@studio/react-utils/hooks';
import type { ReactElement } from 'react';
import { forwardRef, useRef } from 'react';
import { Context } from './context.js';
import { Scaffold } from './scaffold.jsx';
import type { Props as ProviderProps } from './store/index.js';
import { Provider } from './store/index.js';
import type { Props } from './types.js';
import { useWorkflow } from './wiring.js';

const Workflow = forwardRef<Dialog.Api, Omit<Props, keyof ProviderProps>>(
  (props, forwardedRef): ReactElement => {
    const apiRef = useRef<Dialog.Api>(null);
    const wiring = useWorkflow(apiRef);

    return (
      <Dialog.Root ref={useComposedRefs(apiRef, forwardedRef)} {...props}>
        <Dialog.Overlay>
          <Dialog.Panel>
            <Context.Provider value={wiring}>
              <Scaffold />
            </Context.Provider>
          </Dialog.Panel>
        </Dialog.Overlay>
      </Dialog.Root>
    );
  }
);

/** Audio `<Settings>` component. */
export const Settings = forwardRef<Dialog.Api, Props>(
  ({ device, ...props }, forwardedRef): ReactElement => (
    <Provider device={device}>
      <Workflow ref={forwardedRef} {...props} />
    </Provider>
  )
);
